import { PaymentMethodForm } from "../utils/payment_method_form.js";
import { CreateForm } from "../utils/form.js";

frappe.ready(async function () {
  if (frappe.session.user != "Guest") window.location.href = "/subscription/plans";
  let container = document.getElementById("payment-methods-container");
  let form = await PaymentMethodForm.setupFormWithStripeKey();
  container.append(form.form);
  createAccountForm();

  const planName = getUrlParameter("plan_name");
  if (!planName) {
    window.location.href = "/";
  }
  const trial = getUrlParameter("billing") == "trial" ? true : false;

  if (trial) {
    $("#trial-faq").show();
    $("#coupon-section").hide();
    $("#trial-period").show();
  }

  getPlanDetails(planName, trial);

  $("#buy-plan-btn").on("click", async function () {
    $("#buy-plan-btn").prop("disabled", true);
    $("#spinner").show();
    await buyPlan(planName, trial, form.card, form.stripe);
    $("#buy-plan-btn").prop("disabled", false);
    $("#spinner").hide();
  });
  $("#checkout-page-container").show();

  $("#confirm-password").on('blur', function () {
      const val = $(this).val().trim();
      if (val.length >= 3) {
        const password1 = $("#new-password").val();
        const confirmPassword2 = $("#confirm-password").val();

        if (password1 !== confirmPassword2) {
          frappe.msgprint(createMessage("error", "Something Went Wrong!", `Passwords do not match`));
        }
        else {
          validatePasswordStrength(val);
        }
      }
    });
});

function createAccountForm() {
  let form = new CreateForm("account-form", [
    [
      12,
      [
        {
          type: "text",
          id: "user-name",
          label: "Full Name",
          required: true,
        },
      ],
    ],
    [
      12,
      [
        {
          type: "email",
          id: "user-email",
          label: "Email",
          required: true,
        },
      ],
    ],
    [
      12,
      [
        {
          type: "password",
          id: "new-password",
          label: "Password",
          required: true,
        },
      ],
    ],
    [
      12,
      [
        {
          type: "password",
          id: "confirm-password",
          label: "Confirm Password",
          required: true,
        },
      ],
    ],
  ]);
  let container = document.getElementById("account-details-form");
  container.append(form.form);
}

function getUrlParameter(name) {
  const urlParams = new URLSearchParams(window.location.search);
  const paramValue = urlParams.get(name);

  return paramValue ? decodeURIComponent(paramValue) : null;
}

async function getPlanDetails(planName, trial) {
  if (!planName) return;

  let apiUrl = `frappe_stripe_subscription.api.utils.get_subscription_plan_details`;
  await frappe.call({
    async: true,
    method: apiUrl,
    args: {
      plan: planName,
    },
    callback: function (response) {
      const plan = response.message;
      $("#plan-name").html(plan.name);
      let planCost = plan.cost;
      if (trial) {
        planCost = `<s>${plan.cost}</s> 0`;
      }
      $("#plan-cost").html(planCost);
      $("#plan-item").html(plan.item);
      $("#plan-billing-interval").html(plan.billing_interval);
    },
  });
}

async function buyPlan(planName, trial, card, stripe) {
  const userName = $("#user-name").val();
  const userEmail = $("#user-email").val();
  const password = $("#new-password").val();
  const confirmPassword = $("#confirm-password").val();
  const cardName = $("#nameOnCard").val();
  const addrLine = $("#cardAddress").val();
  const city = $("#cardCity").val();
  const state = $("#cardState").val();
  const country = $("#cardCountry").val();
  const postal_code = $("#cardPostalCode").val();

  if (userName == "" || userEmail == "") {
    frappe.show_alert(
      {
        message: __("Please enter User Name and Email for account creation"),
        indicator: "red",
      },
      5,
    );
    return;
  }

  let passwordStrengthCheckPassed = await validatePasswordStrength(password);

  if (!passwordStrengthCheckPassed) return;

  if (password !== confirmPassword) {
    frappe.show_alert(
      {
        message: __("Passwords do not match."),
        indicator: "red",
      },
      5,
    );
    return;
  }

  if (cardName == "") {
    frappe.show_alert(
      {
        message: __("Please enter your name as on the provided card"),
        indicator: "yellow",
      },
      5,
    );
    return;
  }

  if (addrLine == "" || city == "" || state == "" || country == "" || postal_code == "") {
    frappe.show_alert(
      {
        message: __("Please enter complete address details"),
        indicator: "red",
      },
      5,
    );
    return;
  }

  if (!$("#terms-conditions-checkbox").is(":checked")) {
    frappe.show_alert(
      {
        message: __("Please accept Terms and Conditions"),
        indicator: "red",
      },
      5,
    );
    return;
  }

  if (!$("#news-letter-checkbox").is(":checked")) {
    frappe.show_alert(
      {
        message: __("Please accept to receive news and updates"),
        indicator: "red",
      },
      5,
    );
    return;
  }

  if ($("#news-letter-checkbox").is(":checked")) {
    frappe.call({
      method: "frappe_stripe_subscription.api.utils.subscribe_to_rtcamp_list",
      args: {
          email: userEmail,
      }
    });
  }

  let client_secret;

  const billingDetails = {
    name: cardName,
    address: {
      line1: addrLine,
      city: city,
      state: state,
      country: country,
      postal_code: postal_code,
    },
  };

  const { paymentMethod, error_creation } = await stripe.createPaymentMethod({
    type: "card",
    card: card,
    billing_details: billingDetails,
  });

  if (error_creation) {
    frappe.throw(error_creation);
    return;
  }

  const buyData = {
    plan_name: planName,
    user_name: userName,
    user_email: userEmail,
    password: password,
    address_details: billingDetails["address"],
    payment_method: paymentMethod.id,
    trial: trial,
  };

  let error = false;
  await frappe.call({
    async: false,
    method: "frappe_stripe_subscription.api.utils.first_checkout_account_create",
    args: {
      data: buyData,
    },
    callback: function (response) {
      if (response.message) {
        if (response.message.error == 1) {
          error = true;
          frappe.throw(response.message.message);
          return;
        }
      }
      buyData["customer_id"] = response.message.customer;
    },
  });

  if (error) return;

  await frappe.call({
    async: false,
    method: "frappe_stripe_subscription.api.utils.first_checkout_stripe_create",
    args: {
      data: buyData,
    },
    callback: function (response) {
      if ("message" in response.message) {
        frappe.msgprint(createMessage("error", "Something Went Wrong!", `Payment Error : ${response.message.message}\n\nRedirecting to checkout page`));
        setTimeout(function () {
          localStorage.setItem("selectedPlan", planName);
          const trial = getUrlParameter("billing") == "trial" ? true : false;
          localStorage.setItem("trial", trial);
          window.location.href = window.location.origin + "/subscription/checkout";
        }, 2000);
      }
      if (!trial) {
        client_secret = response.message.intent;
      } else {
        frappe.msgprint(createMessage("success", "Congratulations!", "Your trial is now active, and your account has been created successfully!"));
        setTimeout(function () {
          window.location.href = window.location.origin + "/subscription/my-account#apis";
        }, 2000);
      }
    },
  });

  if (!trial && !client_secret) return;

  if (!trial) {
    const { paymentIntent, error_payment } = await stripe.confirmCardPayment(client_secret);

    if (error_payment || paymentIntent.status != "succeeded") {
      frappe.msgprint(createMessage("error", "Something Went Wrong!", `Payment Error : ${response.message.message}\n\nRedirecting to checkout page`));;
      setTimeout(function () {
        localStorage.setItem("selectedPlan", planId);
        window.location.href = window.location.origin + "/subscription/checkout";
      }, 2000);
      return;
    } else if (paymentIntent.status == "succeeded") {
      frappe.msgprint(createMessage("success", "Congratulations!", "Your subscription is now active and Your account has been created successfully!"));
      setTimeout(function () {
        window.location.href = window.location.origin + "/subscription/my-account#purchases";
      }, 2000);
    }
  }
}

async function validatePasswordStrength(password) {
  let passwordStrengthCheckPassed = false;
  await frappe.call({
    method: "frappe_stripe_subscription.api.utils.test_password_strength",
    args: {
      password: password,
    },
    callback: function (r) {
      if (r.message) {
        const score = r.message.score || 0;
        const feedback = r.message.feedback || {};

        if (score < 2) {
          let message;
          if (feedback.suggestions && feedback.suggestions.length > 0) {
            message = `Suggestions: ${feedback.suggestions.join(", ")}`;
          }
          if (feedback.warning) {
            message = `Warning: ${feedback.warning}`;
          }

          frappe.show_alert(
            {
              message: "Please Make sure your password is strong enough." + message,
              indicator: "yellow",
            },
            5,
          );
        } else {
          passwordStrengthCheckPassed = true;
        }
      }
    },
  });

  return passwordStrengthCheckPassed;
}
